module.exports = __webpack_public_path__ + "img/5_26.431073f0.png";